import React, { useState } from 'react'
import Sidebar from '../../../components/Sidebar/Sidebar'
import { Link } from 'react-router-dom'
import './createtemp.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faArrowRight, faBookmark, faPlus, faTrashCan, faClose } from '@fortawesome/free-solid-svg-icons'

function CreateDMTemp() {
    const [openPrev, setOpenPrev] = useState(false)
    const [selectedPlaceholders, setSelectedPlaceholders] = useState([])

    const openPrevPlaceHolders = () => {
        setOpenPrev(!openPrev)
    }

    const checkedPrev = (id) => {
        const itemPicked = dummyPlaceHolders.find((item) => item.id === id);
        const newArr = [...selectedPlaceholders];
    
        // Check if the item is already in the array
        const index = newArr.findIndex((item) => item.id === id);
    
        if (index !== -1) {
            // If the item is found, remove it from the array
            newArr.splice(index, 1);
        } else {
            // If the item is not found, add it to the array
            newArr.push(itemPicked);
        }
    
        setSelectedPlaceholders(newArr);
    };
    
    console.log(selectedPlaceholders);

    const dummyPlaceHolders = [
        {
            name: 'Append CFO Initial',
            id: 0
        },
        {
            name: 'Enter Division',
            id: 1
        },
        {
            name: 'Enter Suit Number',
            id: 2
        },
        {
            name: 'Enter Claimant',
            id: 3
        },
        {
            name: 'Enter Defendant',
            id: 4
        },
        {
            name: 'Enter Affidavit in Support Type',
            id: 5
        },
        {
            name: 'Enter Deponent Full Name',
            id: 6
        },
        {
            name: 'Enter Gender',
            id: 7
        },
        {
            name: 'Enter Religion',
            id: 8
        },
        {
            name: 'Enter Occupation',
            id: 9
        },
        {
            name: 'Enter Address',
            id: 10
        },
    ]

    // useEffect(() => {
    //     if
    // }, [])

  return (
    <div className='create-temp-dm'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>Hi, Joseph Sanni</h2>
                    </div>
                    <p>Your role: Document Manager</p>
                </div>
                <p className="nav-status">Home/e-DM-dashboard/create-doc</p>
            </div>
            <div className="back" onClick={() => window.history.back()}>
                <Link><FontAwesomeIcon icon={faAngleLeft} /> Back</Link>
            </div>
            <div className="dashboard-view">
                <h2>Setup Template Placeholders</h2>
                <div className="create-box">
                    <div className="left-form">
                        <div className="form-body">
                            <div className="form-inp">
                                <label htmlFor="placeholderName">Placeholder Name</label>
                                <input type="text" placeholder='e.g Firstname placeholder' id='placeholderName'/>
                            </div>
                            <div className="form-inp">
                                <label htmlFor="placeholderText">Placeholder Text</label>
                                <input type="text" placeholder='e.g [FIRSTNAME]' id='placeholderText'/>
                            </div>
                            <div className="form-inp">
                                <label htmlFor="typetemp">Placeholder Name</label>
                                <select id="typetemp">
                                    <option value="" disabled selected>--Select Type--</option>
                                    <option value="normal">TEXT[NORMAL]</option>
                                    <option value="textarea">TEXT[TEXTAREA]</option>
                                    <option value="multipleinput">TEXT[MULTIPLE-INPUT]</option>
                                    <option value="multipletextarea">TEXT[MULTIPLE-TEXTAREA]</option>
                                    <option value="legalcounselcontact">TEXT[LEGAL-COUNSEL-CONTACT]</option>
                                    <option value="detailandservice">TEXT[DETAIL-AND-SERVICE-ADDRESS-SECTION]</option>
                                    <option value="cfodate">CFO-DATE</option>
                                    <option value="cfodatetime">CFO-DATE-TIME-STAMP</option>
                                    <option value="counseldate">COUNSEL-DATE</option>
                                    <option value="passport">UPLOADED MEDIA[PASSPORT]</option>
                                    <option value="exhibit">UPLOADED MEDIA[EXHIBIT]</option>
                                    <option value="sealdeponent">UPLOADED MEDIA[SEAL-DEPONENT]</option>
                                    <option value="sealcommissioner">UPLOADED MEDIA[SEAL-COMMISSIONER]</option>
                                    <option value="stampdeponent">UPLOADED MEDIA[STAMP-DEPONENT]</option>
                                    <option value="stampcommissioner">UPLOADED MEDIA[STAMP-COMMISSIONER]</option>
                                    <option value="signdeponent">UPLOADED MEDIA[SIGNATURE-DEPONENT]</option>
                                    <option value="signcommissioner">UPLOADED MEDIA[SIGNATURE-COMMISSIONER]</option>
                                </select>
                            </div>
                            <div className="form-inp">
                                <label htmlFor="formHint">Hint</label>
                                <input type="text" id='formHint'/>
                            </div>
                            <button className="addPlace"><FontAwesomeIcon icon={faPlus} /> Add Placeholder</button>
                            <button className='viewPrev' onClick={() => openPrevPlaceHolders()}><FontAwesomeIcon icon={faBookmark} /> View Existing Placeholders</button>
                        </div>
                        <Link to='/edm/create-temp/doc-create'><button className="red">Next <FontAwesomeIcon icon={faArrowRight} /></button></Link>
                    </div>
                    { selectedPlaceholders.length > 0 ? <div className="right-placeholders">
                        <h3>Added Placeholders</h3>
                        <div className="added-items">
                            {
                                selectedPlaceholders.map((item, id) => { return(
                                    <div className="placeholder" key={id}>
                                        <p>{item.name}</p>
                                        <FontAwesomeIcon icon={faTrashCan} className='trash'/>
                                    </div>
                                )})
                            }
                        </div>
                    </div> : null}
                </div>
            </div>
            <div className={ openPrev ? "select-prev open" : "select-prev"}>
                <div className="select-wrapper">
                    <div className="heading">
                        <h2>Select from existing placeholders below</h2>
                        <div className="icon" onClick={() => openPrevPlaceHolders()}>
                            <FontAwesomeIcon icon={faClose} />
                        </div>
                    </div>
                    <div className="prev-place">
                        {
                            dummyPlaceHolders.map((item, id) => {
                                return (
                                    <div className="item" key={id}>
                                        <input
                                            type="checkbox"
                                            id={item.id}
                                            onChange={() => checkedPrev(item.id)}
                                            // You can also use checked={item.isChecked} if you have a checked state in your item object
                                        />
                                        <label htmlFor={item.id}>{item.name}</label>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="pagination">
                        <div className="prev">
                            <FontAwesomeIcon icon={faAngleDoubleLeft} />
                            <p>Previous</p>
                        </div>
                        <div className="page-btns">
                            <button>1</button>
                            <button>2</button>
                            <button>3</button>
                        </div>
                        <div className="prev">
                            <p>Next</p>
                            <FontAwesomeIcon icon={faAngleDoubleRight} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CreateDMTemp